"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.spacing = void 0;

/** spacing used by the padding, margin, width, height, maxHeight, gap,
 * inset, space, and translate core plugins. */
// if you need negative values, just prepend with '-'
// e.g. border-radius: -${theme.spacing['3']};
// rem calculated based on typography.js rootFontSize
var spacing = {
  0: '0rem',
  1: '0.07692307692307693rem',
  // 1px
  2: '0.15384615384615385rem',
  // 2px
  3: '0.3076923076923077rem',
  // 4px
  4: '0.46153846153846156rem',
  // 6px
  5: '0.6153846153846154rem',
  // 8px
  6: '0.7692307692307693rem',
  // 10px
  7: '0.9230769230769231rem',
  // 12px
  8: '1rem',
  // 13px
  base: '1rem',
  // 13px
  9: '1.0769230769230769rem',
  // 14px
  10: '1.2307692307692308rem',
  // 16px
  11: '1.5384615384615385rem',
  // 20px
  12: '1.8461538461538463rem',
  // 24px
  13: '2.1538461538461537rem',
  // 28px
  14: '2.4615384615384617rem',
  // 32px
  15: '2.769230769230769rem',
  // 36px
  16: '3.076923076923077rem',
  // 40px
  // 42px
  17: '3.3846153846153846rem',
  // 44px
  18: '3.6923076923076925rem',
  // 48px
  19: '4.3076923076923075rem',
  // 56px
  20: '4.923076923076923rem',
  // 64px
  21: '6.153846153846154rem',
  // 80px
  22: '7.384615384615385rem',
  // 96px
  23: '7.6923076923076925rem',
  // 100px
  24: '9.846153846153847rem' // 128px

};
exports.spacing = spacing;
//# sourceMappingURL=spacing.js.map